import axios from "axios";
import Env from "./env";

const environment = new Env();

const apiUrl = environment.apiUrl;
const apiStorage = environment.apiStorage;

function apiFunction() {
  try {
    // Créer la requête axios avec les valeurs mises à jour
    const instance = axios.create({
      baseURL: apiUrl,
      headers: {
        "Content-Type": "application/json",
      },
    });

    instance.interceptors.request.use(
      async (config) => {
        // /token est le seul endpoint sans auth header
        if (config.url?.includes("/token")) return config;

        // Login et register exigent les identifiants par défaut de /token,
        // jamais une session stockée (potentiellement expirée)
        const publicEndpoints = ["/account/login", "/account/register"];
        const isPublic = publicEndpoints.some((ep) => config.url?.includes(ep));
        if (isPublic) {
          const tokenResponse = await axios.get(`${apiUrl}/token`);
          config.headers.Authorization =
            "Basic " +
            btoa(tokenResponse.data.username + ":" + tokenResponse.data.password);
          return config;
        }

        // Mettre à jour les en-têtes avec les dernières valeurs du token avant chaque requête
        let userId = localStorage.getItem("userId");
        let sessionKey = localStorage.getItem("accessToken");

        // Si les tokens n'existent pas en localStorage, faire une requête GET à /token
        if (!userId || !sessionKey) {
          try {
            const tokenResponse = await axios.get(`${apiUrl}/token`);
            userId = tokenResponse.data.username;
            sessionKey = tokenResponse.data.password;
            // Stocker les valeurs dans localStorage pour les requêtes futures
            localStorage.setItem("userId", userId);
            localStorage.setItem("accessToken", sessionKey);
          } catch (tokenError) {
            console.error(
              "Erreur lors de la récupération du token:",
              tokenError
            );
            // Retourner l'erreur si les tokens ne peuvent pas être récupérés
            throw new Error(
              "Impossible de récupérer les tokens d'authentification"
            );
          }
        }

        config.headers.Authorization =
          "Basic " + btoa(userId + ":" + sessionKey);

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    return instance;
  } catch (error) {
    // throw error;
  }
}

function apiStorageFunction() {
  try {
    // Créer la requête axios avec les valeurs mises à jour
    const instance = axios.create({
      baseURL: apiStorage,
      /* headers: {
                "Content-Type": "multipart/form-data",
              }, */
    });
    return instance;
  } catch (error) {
    // throw error;
  }
}

const api = apiFunction();
const apiS = apiStorageFunction();

export { api, apiUrl, apiS };
